import { allow } from '../classes/allow';
import emptyFunction from '../objects/constants/empty.function';
import is from '../objects/is';

const data: any = {};
data['success@success.com'] = {Success1: {errorCode: '', isTemporaryPassword: false, redirect: '/login'}};

export default function useMockLoginApi() {
    const login = (username = '', password = '', callBack: Function = emptyFunction) => {
        allow.aString(username, is.not.empty).aString(password, is.not.empty).aFunction(callBack);
        console.log('reached the mock');
    };

    return {
        login,
    };
}

